import useUserPermission from "~/hooks/useUserPermission";

export const useDatasetAssistant = (): boolean => {
  return useUserPermission("use:agents");
};

export default useDatasetAssistant;
